;(function () {

    //Documentation https://developers.google.com/tag-manager/enhanced-ecommerce?hl=ru

    window.dataLayer = window.dataLayer || []

    function _getCatalogMode () {
        var $mode_btn = $('.catalog-options__button--active')
        return $mode_btn.length ? $mode_btn.data('gtm-list') : 'Unknown'
    }

    function _sendClickProduct (product, list, url) {
        dataLayer.push({
            'event': 'EE_ProductClick',
            'ecommerce': {
                'click': {
                    'actionField': {'list': list},
                    'products': [product],
                }
            },
            'eventCallback': function () {
                document.location = url
            }
        })
    }

    function _sendImpressions (products, list) {
        var products_gtm = []
        for (var i in products) {
            if (products.hasOwnProperty(i)) {
                var product = products[i]
                product['list'] = list
                products_gtm.push(product)
            }
        }

        dataLayer.push({
            'event': 'EE_Impressions',
            'ecommerce': {
                'currencyCode': 'RUB',
                'impressions': products_gtm
            }
        })
    }

    function _sendProductDetail (product) {
        dataLayer.push({
            'event': 'EE_ProductDetail',
            'ecommerce': {
                'detail': {
                    'actionField': {},    // 'detail' actions have an optional list property.
                    'products': [product]
                }
            }
        })
    }

    function _sendAddCart (products, list) {
        dataLayer.push({
            'event': 'EE_AddToCart',
            'list': list,
            'ecommerce': {
                'currencyCode': 'RUB',
                'add': {
                    'products': products
                }
            }
        })
    }

    function _sendRemoveFromCart (product, list) {
        dataLayer.push({
            'event': 'EE_RemoveFromCart',
            'list': list,
            'ecommerce': {
                'currencyCode': 'RUB',
                'remove': {
                    'products': [product]
                }
            }
        })
    }

    function _sendCheckout (checkout) {
        if (checkout.length) {
            for (var i in checkout) {
                if (checkout.hasOwnProperty(i)) {
                    dataLayer.push({
                        'event': 'EE_Checkout',
                        'ecommerce': {
                            'checkout': checkout[i]
                        }
                    })
                }
            }
        } else {
            dataLayer.push({
                'event': 'EE_Checkout',
                'ecommerce': {
                    'checkout': checkout
                }
            })
        }
    }

    function _sendCheckoutOption(step, checkoutOption) {
        dataLayer.push({
            'event': 'EE_CheckoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': {'step': step, 'option': checkoutOption}
                }
            }
        });
    }

    function _sendPurchase (purchase, order_info) {
        dataLayer.push({
            'event': 'EE_Purchase',
            'order': order_info,
            'ecommerce': {
                'purchase': purchase
            }
        })
    }

    function _onCatalogImpressionProducts () {
        _sendImpressions(window.gtm_impression_products, _getCatalogMode())
    }

    function init () {
        if (window.gtm_impression_products) {
            _onCatalogImpressionProducts()
        }

        if (window.gtm_detail_product) {
            _sendProductDetail(window.gtm_detail_product)
        }

        if (window.gtm_checkout) {
            _sendCheckout(window.gtm_checkout)
        }

        if (window.gtm_purchase) {
            _sendPurchase(window.gtm_purchase, window.gtm_order_info)
        }

        $(document).on('click', '.catalog-options__button', function () {
            _onCatalogImpressionProducts()
        })

        $(document).on('click', '.js-product-link', function () {
            var $this = $(this),
                $product = $this.closest('.catalog__item'),
                gtm_product = window.gtm_impression_products[$product.data('id')]

            if (gtm_product) {
                _sendClickProduct(gtm_product, _getCatalogMode(), $this.prop('href'))
            }
        })

        $(document).on('cartAdd', function (e, list, products) {
            _sendAddCart(products, list)
        })
        $(document).on('cartRemove', function (e, list, products) {
            _sendRemoveFromCart(products, list)
        })

        $(document).on('shippingChange', function (e, name) {
            _sendCheckoutOption(3, name)
        })
        $(document).on('paymentChange', function (e, name) {
            _sendCheckoutOption(4, name)
        })
    }

    init()
})()
